// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d855a71b","667":"86d3f1bf","977":"2caed02d"}[chunkId] + ".chunk.js";
};